import React from 'react';
import { useNavigate } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditProduct from '../../components/products/Form/FormAddEditProduct';

const CreateProduct = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProduct
                isEdit={false}
                onSubmitSuccess={() => navigate('/products')}
            />
        </WrapperSection>
    );
};

export default CreateProduct;
